export default "__VITE_ASSET__BjELVAW2__"